<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link :to="{ path: BACKEND_URL + '/organisations/edit', props: { id: organisation.id } }" v-if="$can('organisation-edit')">
        <action-button type="edit" />
      </router-link>
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.name"
                  v-model="organisation.name"
                  :label="$t('organisations.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.email"
                  v-model="organisation.email"
                  :label="$t('organisations.email')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.vat"
                  v-model="organisation.vat"
                  :label="$t('organisations.vat')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.phone"
                  v-model="organisation.phone"
                  :label="$t('organisations.phone')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 d-none>
                <v-checkbox name="organisation.owner" v-model="organisation.owner" :label="$t('organisations.owner')" readonly></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.phone"
                  :value="organisation.customer_groups ? organisation.customer_groups.map((a) => a.name).join(', ') : ''"
                  :label="$t('organisations.phone')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex lg4 md5 sm7 xs12>
                <img height="80" max-width="300" max-height="80" v-bind:src="imgData" v-show="showLogo" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.invoice_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.po_number"
                  :label="$t('organisations.po_number')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.invoice_ref"
                  :label="$t('organisations.invoice_ref')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.email_invoice"
                  :label="$t('organisations.email_invoice')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.visiting_address_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="visiting_address.street"
                  v-model="visiting_address.street"
                  :label="$t('organisations.visiting_street')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="visiting_address.city"
                  v-model="visiting_address.city"
                  :label="$t('organisations.visiting_city')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="visiting_addressg.state"
                  v-model="visiting_address.state"
                  :label="$t('organisations.visiting_state')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="visiting_address.zip"
                  v-model="visiting_address.zip"
                  :label="$t('organisations.visiting_zip')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="visiting_address.country"
                  :value="this.$dd_countries(visiting_address.country)"
                  :label="$t('organisations.visiting_country')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.invoice_address_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.street"
                  v-model="invoice_address.street"
                  :label="$t('organisations.invoice_street')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.city"
                  v-model="invoice_address.city"
                  :label="$t('organisations.invoice_city')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.state"
                  v-model="invoice_address.state"
                  :label="$t('organisations.invoice_state')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.zip"
                  v-model="invoice_address.zip"
                  :label="$t('organisations.invoice_zip')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.country"
                  :value="this.$dd_countries(invoice_address.country)"
                  :label="$t('organisations.invoice_country')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "OrganisationView",

  data() {
    return {
      page_title: "",
      organisation: {},
      visiting_address: {},
      invoice_address: {},
      url: "",
      imgData: "",
      showLogo: false
    }
  },

  computed: {
    id: {
      get() {
        return this.$store.getters["organisations/organisationId"]
      }
    }
  },

  watch: {
    id: {
      handler: function (val) {
        this.load()
      }
    }
  },

  created() {
    if (this.id) this.load()
  },

  methods: {
    load() {
      axios
        .get(this.API_URL + "organisation/" + this.id)
        .then((res) => {
          this.organisation = res.data.data
          this.visiting_address = res.data.data.addresses.visiting
          this.invoice_address = res.data.data.addresses.invoice

          this.page_title = this.$t("organisations.view_organisation", { name: this.organisation.name })
        })
        .catch((err) => console.log(err))

      this.getImage()
    },
    getImage() {
      let vm = this
      var endpoint = this.GET_LOGO
      axios.get(this.API_URL + endpoint + "?id=" + this.id).then((response) => {
        if (response.data.success == true) {
          vm.imgData = decodeURIComponent(response.data.logo)
          this.showLogo = true
          this.hasLogo = true
        }
      })
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "organisation/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/organisations")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
